import './activationCodeRestService';
import './appInstanceRestService';
import './appIntegrationRestService';
import './appsRestService';
import './baseRestService';
import './deployRestService';
import './deviceRestService';
import './logoutRestService';
import './actionsRestService';
import './eventRestService';
import './licenseRestService';
import './oauth';
import './passwords';
import './transactionRestService';
import './userRestService';
import './userNotificationsRestService';
import './profileImageRestService';
import './paymentTypesRestService';
import './deploymentUrlsRestService';
import './alertSearchRestService';
import './gdprActionsRestService';
import './gdprReportsRestService';
import './recommendationsRestService';
import './paymentsRestService';
import './paymentUrlsRestService';
import './appPricesRestService';
import './flexiblePromotionsRestService';
import './changePaymentUrlsRestService';



// WEBPACK FOOTER //
// ./scripts/restServices/index.js